import { ConfiguableSvgProps } from 'src/components/Icons/types';

type Props = Omit<ConfiguableSvgProps, 'color'>;

export default function OrderbookVertical({
	width = 16,
	height = 16,
	className,
}: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="none"
			className={className}
		>
			<rect width="12" height="2.667" x="2" y="12" fill="#2BA866" rx=".5" />
			<rect
				width="7.333"
				height="2.667"
				x="2"
				y="8.667"
				fill="#2BA866"
				rx=".5"
			/>
			<rect
				width="7.333"
				height="2.667"
				x="2"
				y="4.667"
				fill="#E2563D"
				rx=".5"
			/>
			<rect width="12" height="2.667" x="2" y="1.333" fill="#E2563D" rx=".5" />
		</svg>
	);
}
